/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInsightComments.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/insight-comments";

export class AutogenModelInsightComments<RowType extends ModelRow> extends Endpoint<RowType, RowInsightCommentsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInsightComments extends ModelRow<RowInsightCommentsFields> {
	constructor(values?: Partial<RowInsightCommentsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInsightCommentsFields {
	attach_filename: string;
	attachment: string;
	comment_type_id: string;
	comments: string;
	company_id: string;
	copy_to_order: string;
	display_atdispatch: string;
	entered_date: Date;
	entered_user_id: string;
	id: string;
	onboard_lock: string;
	order_comment_type: string;
	parent_row_id: string;
	parent_row_type: string;
	rmis_image_id: string;
}

